import { WidgetHeaderContentActionsEditButton } from '../WidgetHeaderContentActionsEditButton'
import { WidgetHeaderContentActionsExpandButton } from '../WidgetHeaderContentActionsExpandButton'

import * as styles from './WidgetHeaderContentActions.module.css'

function WidgetHeaderContentActions({
  AddButton,
  AdditionalActions,
  EditButton = WidgetHeaderContentActionsEditButton,
  ExpandButton = WidgetHeaderContentActionsExpandButton,
  addButtonProps,
  additionalActionsProps,
  className = styles.WidgetHeaderContentActions,
  editButtonProps,
  expandButtonProps,
  isHovered,
}) {
  return (
    <div className={className}>
      {AddButton ? (
        <>
          {AdditionalActions ? (
            <AdditionalActions
              {...additionalActionsProps}
              isHovered={isHovered}
            />
          ) : null}
          <AddButton {...addButtonProps} isHovered={isHovered} />
        </>
      ) : (
        <>
          {EditButton ? (
            <EditButton {...editButtonProps} isHovered={isHovered} />
          ) : null}
          {AdditionalActions ? (
            <AdditionalActions
              {...additionalActionsProps}
              isHovered={isHovered}
            />
          ) : null}
        </>
      )}
      {ExpandButton ? <ExpandButton {...expandButtonProps} /> : null}
    </div>
  )
}

export default WidgetHeaderContentActions
